import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import ColorsFilter from 'components/essentials/ColorsFilter';

const PDPUpholsteryColorFilters = ({
  selectedColor,
  setSelectedColor,
  variant,
  showRowInMobile = false,
  showMobileColorFilter = false,
}) => {
  const colors = useMemo(() => {
    if (typeof selectedColor === 'string' || selectedColor === null) {
      return { [selectedColor]: true };
    }

    return selectedColor.reduce((obj, item) => {
      obj[item] = true;
      return obj;
    }, {});
  }, [selectedColor]);

  const handleSelectColor = color => {
    if (typeof selectedColor === 'string' || selectedColor === null)
      setSelectedColor(color !== selectedColor ? color : null);
    else setSelectedColor(color);
  };
  return (
    <ColorsFilter
      colors={[
        'beige/white',
        'black',
        'blue',
        'brown',
        'green',
        'gray',
        'orange',
        'pink',
        'red',
        'white',
        'yellow',
      ]}
      onSelectColor={color => handleSelectColor(color)}
      selectedColors={colors}
      variant={variant}
      showRowInMobile={showRowInMobile}
      showMobileColorFilter={showMobileColorFilter}
    />
  );
};

PDPUpholsteryColorFilters.propTypes = {
  selectedColor: PropTypes.string,
  setSelectedColor: PropTypes.func,
  variant: PropTypes.oneOf(['PDPFullScreenViewUI']),
  showRowInMobile: PropTypes.bool,
  showMobileColorFilter: PropTypes.bool,
};

export default PDPUpholsteryColorFilters;
